// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print {\n.no-print[data-v-32a64b3c] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
